import environment from '../config'
import { CognitoUserPool, AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import * as AWS from 'aws-sdk/global'
import * as STS from 'aws-sdk/clients/sts'

const auth = {
  name: 'auth',
  data() {
    return {
      userPool: ''
    }
  },
  created() {
    AWS.config.region = environment.region;
    let poolData = {
      UserPoolId: environment.userPoolId,
      ClientId: environment.clientId
    }
    this.userPool = new CognitoUserPool(poolData);
  },
  methods: {
    isAuthenticated(callback) {
      let user = this.userPool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            console.log('Get Session Error: ', err)
            callback('not authenticated');
            return
          }
          if (session) {
            if (session && session.isValid()) {
              console.log('Valid Session')
              this.setCredentials(session.getIdToken().getJwtToken(), callback)
              console.log(session)
              this.$store.commit('setUserName', { user: user, session: session})
              return user
            } else {
              console.log('Session expired...attempting to use refresh token..')
              let refreshToken = session.getRefreshToken()
              if (refreshToken) {
                console.log('refreshing user')
                this.refreshSession(refreshToken, session.getIdToken().getJwtToken(), callback)
              }
            }
          }
        });
      } else {
        callback('not authenticated');
      }
    },
    setCredentials(token, callback) {
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.identityPoolId,
        Logins: {
          [`cognito-idp.${environment.region}.amazonaws.com/${environment.userPoolId}`]: token
        }
      });
      this.$store.commit('signIn')
      this.refreshCredentials(callback)
    },
    refreshSession(refreshToken, idToken, callback) {
      let user = this.userPool.getCurrentUser();
      if (user && refreshToken && idToken) {
        user.refreshSession(refreshToken, (err, session) => {
          if (err) {
            console.log('Refresh Session Error: ', err);
            return;
          }
          if (session && session.isValid()) {
            console.log(session)
            this.setCredentials(session.getIdToken().getJwtToken(), callback);
            console.log('Refreshed id token');
            this.$store.committ('setUserName', { user: user, session: session })
            callback(user)
          }
        });
      }
    },
    refreshCredentials(callback) {
      if (AWS.config.credentials) {
        AWS.config.credentials.refresh((error) => {
          if (error) {
            console.error(error);
          } else {
            callback(this.userPool.getCurrentUser());
            console.log('Credentials refreshed');
          }
        });
      }
    },
    setNewPassAndLogin(username, currentPass, newPass, callback) {
      this.login(username, currentPass, callback, newPass);
    },
    createAccount(username, email, password, callback) {

      let poolData = {
        UserPoolId: environment.userPoolId,
        ClientId: environment.clientId
      }
      var userPool = new CognitoUserPool(poolData);
      var attributeList = [];

      var dataEmail = {
          Name : 'email',
          Value : email
      };
      var attributeEmail = new CognitoUserAttribute(dataEmail);
      attributeList.push(attributeEmail);

      userPool.signUp(username, password, attributeList, null, function(err, result){
          if (err) {
              callback(err, null);
              return;
          }
          let cognitoUser = result.user;
          console.log('User name is ' + cognitoUser.getUsername());
          callback(null, result.user);
          return;
      });

    },
    login(username, password, callback, newPass) {
      let authenticationData = {
        Username: username,
        Password: password,
      };
      let userData = {
        Username: username,
        Pool: this.userPool
      };
      let authDetails = new AuthenticationDetails(authenticationData);
      let user = new CognitoUser(userData);
      let challengeCallbacks = {
        onSuccess: (result) => {
            console.log('Challenge Success: ', result)
            callback(null, 'SUCCESS')
        },
        onFailure: (err) => {
            console.log('Challenge Error: ', err)
            callback(err, 'FAILURE')
        }
      }
      user.authenticateUser(authDetails, {
        newPasswordRequired: () => {
          if (newPass) {
            user.completeNewPasswordChallenge(newPass, null, challengeCallbacks);
          } else {
            callback(null, 'NEW_PASS');
          }
        },
        onSuccess: (result) => {
          this.setCredentials(result.getIdToken().getJwtToken(), callback);
          new STS().getCallerIdentity((err) => {
            if (err) {
              console.error('STS Error: ', err);
            } else {
              console.log('Set credentials!');
            }
          });
          const theUser = this.userPool.getCurrentUser()
          theUser.getSession((err, session) => {
            if (err) {
              console.log(err);
            } else {
              this.$store.commit('signIn')
              this.$store.commit('setUserName', { user: theUser, session: session})
            }
          })
          callback(null, 'SUCCESS');
        },
        onFailure: (err) => {
          console.log('AuthFailure: ', err);
          callback(err, 'FAILURE');
        }
      });
    },
    logout() {
      let user = this.userPool.getCurrentUser();
      if (user) {
        user.signOut();
        this.$store.commit('signOut')
        this.$store.commit('signOut')
        this.$store.commit('setUserName', { user: '', session: null })
      }
    },
    uploadFile(fileel) {
      this.refreshCredentials(() => {
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          params: {Bucket: 'lexikitchen'}
        });
        var files = fileel.files;
        if (!files.length) {
          return alert('Please choose a file to upload first.');
        }
        var file = files[0];
        var fileName = file.name;

        var filekey = fileName;
        s3.upload({
          Key: filekey,
          Body: file,
          ACL:'public-read'
        }, function(err, data) {
          if (err) {
            console.log(err);
            return alert('There was an error uploading your photo: ', err.message);
          }
          console.log(data);
          alert('Successfully uploaded photo. Image url: ' + data.Location);
        });
      });
    },
    compressImage(event) {
      const width = 300;
      const fileName = event.target.files[0].name;
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = event => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const elem = document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob((blob) => {
              new File([blob], fileName, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
              });
          }, 'image/jpeg', 1);
        },
        reader.onerror = error => console.log(error);
      };
    }
  }
}

export default auth
